/* eslint-disable import/prefer-default-export */
import { TranslationContactUsMessages, ContactUsMessages } from "../interfaces";

export const messages: TranslationContactUsMessages = {
  [ContactUsMessages.developedBy]: "TopconFLEET é desenvolvido por",
  [ContactUsMessages.topcon]: "Topcon - The Concrete Company.",
  [ContactUsMessages.allRightsReserved]: "Todos os direitos reservados"
};
